<template>
  <v-navigation-drawer
    id="left-drawer"
    style="overflow-y: scroll;"
    clipped
    app
    width="250"
    class="brown lighten-5"
  >
    <drawer-content />
  </v-navigation-drawer>
</template>

<script>
import DrawerContent from './DrawerContent.vue'
export default {
  components: {
    DrawerContent
  }
}
</script>

<style>
#left-drawer::-webkit-scrollbar {
  display: none;
}
#left-drawer > div.v-navigation-drawer__content::-webkit-scrollbar {
  display: none;
}
</style>
